import { render, staticRenderFns } from "./DetailsReaderPrimitive.vue?vue&type=template&id=d1ffb1f6&"
import script from "./DetailsReaderPrimitive.vue?vue&type=script&lang=js&"
export * from "./DetailsReaderPrimitive.vue?vue&type=script&lang=js&"
import style0 from "./DetailsReaderPrimitive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports